/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { EventId } from '@jira/forge__forge-ui-types/src/common/types/analytics.tsx';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import { OPERATIONAL_ACTIONS } from '../../../constants.tsx';
import { fireOperationalEvent } from '../consumers/index.tsx';

export const fireOperationalFailedEvent = ({
	eventId,
	attributes,
}: {
	eventId: EventId;
	attributes?: Attributes;
}): void => {
	fireOperationalEvent(OPERATIONAL_ACTIONS.FAILED, {
		id: eventId,
		attributes,
	});
};
